import React, {useState, useEffect} from "react";
import Header from "../Components/Header";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ReactSession } from 'react-client-session';
ReactSession.setStoreType("localStorage");


function Addcategory() {
   const userId=ReactSession.get("welbeingId");
    const navigate = useNavigate();
    const[formData, setfromData]= useState({});
    const [category, setcategory] = useState([]);
    const [error, setError] = useState("");

    if(userId  <= 0 ){
      navigate('/login');
   }
   
    useEffect(() => {
    const category = async() =>{
        try{
            const response = await axios.get('https://api.welbeing.in/admin/categories/categories/');
            // console.log(response.data);
            if(response.data.status==="success"){
            
            setcategory(response.data.data);
            }else{
               console.error(response.data.error?.message);
            }
        }catch (err) {
             setError(err.message);
                
        }
    };
       category();
    }, []);

    const handlechange =(e)=>{
        const name=e.target.name;
        const value=e.target.value;
        setfromData(values=> ({...values, [name]:value}))

    }


    const handlesubmit = async(e) =>{
        e.preventDefault();
        // console.log(formData);

        try{
          const response = await axios.post('https://api.welbeing.in/admin/categories/add-subcategory/', formData);
            // console.log(response.data);
          if(response.data.status === "success"){
            navigate("/category");
          }else{
            // console.log(response.error);
          }
        }catch (err) {
             setError(err.message);
                
        }
    };


  return (
    <>
       
        <Header/>
        <div class="page-wrapper" id="main-wrapper" data-layout="vertical" data-sidebartype="full" data-sidebar-position="fixed" data-header-position="fixed">
        
        
           <div class="body-wrapper">
            
        
             <div class="container-fluid">
       
        <div class="card bg-light-info shadow-none position-relative overflow-hidden">
            <div class="card-body px-4 py-3">
                <div class="row align-items-center">
                    <div class="col-9">
                        <h4 class="fw-semibold mb-8">Categories</h4>
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><a class="text-muted" href="index-2.html">Dashboard</a></li>
                                <li class="breadcrumb-item" aria-current="page">Categories</li>
                            </ol>
                        </nav>
                    </div>
                    <div class="col-3">
                        <div class="text-center mb-n5">  
                            <img src="dist/images/breadcrumb/ChatBc.png" alt="" class="img-fluid mb-n4"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>



        <div class="row">
              <div class="col-12">
                      
                <div class="card">
                  <div class="card-body">
                    <div class="mb-2">
                      <h5 class="mb-0"></h5>
                    </div><div class="card">
                              <div class="card-body">
                               <div class="mb-3">
                      <h5 class="mb-0">Add New Subcategories</h5>
                    </div>
                    <form onSubmit={handlesubmit}>
                      <div class="form-body">
                        <div class="row">
                          <div class="col-md-6">
						                <div class="mb-3">
                              <label>Categories</label>
                             <select 
                                                                        className="form-control" 
                                                                        name="m_cate"
                                                                        value={formData.m_cate || ''}
                                                                        onChange={handlechange}
                                                                        required
                                                                    >
                                                                        <option value="">-- Select Category --</option>
                                                                        {category.map((item) => (
                                                                            <option key={item.cat_id} value={item.cat_id}>
                                                                                {item.cate}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                            </div>
                            </div>
							              <div class="col-md-6">
                            <div class="mb-3">
                              <label>Sub Category Name</label>
                              <input type="text" class="form-control" name="sub_cate" value={formData.sub_cate} onChange={handlechange}/>
                            </div>
                          </div>
                          
						   
                        </div>
                       
                      </div>
                      <div class="form-actions">
                        <div class="text-start">
                          <button  class="btn btn-light-primary text-primary font-medium mb-5"> Submit </button>
                        </div>
                      </div>
                    </form>
					
					
					
                    
            </div>
          </div></div></div></div></div>

        
       
             </div>
            </div>
        </div>
        </>
  )
}
export default Addcategory;

